/* Kollektion: Chips, Sortierung, „Weitere laden“ – nur auf Kollektionsseiten (benötigt dm.js) */
(() => {
  const { $, $$, eur, cfg, readWish, writeWish, paintWish, closeDialog } = window.dm;
  /* ---------- Kollektion: Chips, Sortierung, „Weitere laden“ (clientseitig) ---------- */
  class DmCollection extends HTMLElement {
    connectedCallback() {
      this.grid = $('[data-dm-grid]', this);
      this.items = $$('[data-dm-item]', this);
      this.items.forEach((li, i) => { li.dataset.order = i; const c = li.querySelector('.dm-card'); if (c) Object.assign(li.dataset, { world: c.dataset.world, pano: c.dataset.pano, price: c.dataset.price, title: c.dataset.title }); });
      this.step = parseInt(this.dataset.step || '24', 10);
      this.shown = this.step;
      this.filter = 'all';
      this.addEventListener('click', (e) => {
        const chip = e.target.closest('[data-dm-chip]');
        if (chip) { this.filter = chip.dataset.dmChip; this.shown = this.step; $$('[data-dm-chip]', document).forEach((c) => c.setAttribute('aria-pressed', c.dataset.dmChip === this.filter ? 'true' : 'false')); this.render(); const sheet = chip.closest('.dm-sheet'); sheet && closeDialog(sheet); }
        if (e.target.closest('[data-dm-more]')) { this.shown += this.step; this.render(); }
      });
      $$('[data-dm-sort]', this).forEach((s) => s.addEventListener('change', () => { $$('[data-dm-sort]', this).forEach((o) => (o.value = s.value)); this.sort(s.value); }));
      // Ansicht „Im Raum / Nur Motiv“ (Kategorie v2): Klasse dm-flat am <html>, gemerkt in localStorage['dm-view']
      const setView = (v) => { document.documentElement.classList.toggle('dm-flat', v === 'flat'); $$('[data-dm-view]', this).forEach((b) => b.setAttribute('aria-pressed', b.dataset.dmView === v ? 'true' : 'false')); };
      this.addEventListener('click', (e) => { const b = e.target.closest('[data-dm-view]'); if (!b) return; setView(b.dataset.dmView); try { localStorage.setItem('dm-view', b.dataset.dmView); } catch (er) {} });
      setView(document.documentElement.classList.contains('dm-flat') ? 'flat' : 'room');
      // Mobile Filterleiste klebt unter dem (klebenden) Shop-Kopf
      const head = document.querySelector('.shopify-section-group-header-group.dm-sticky') || document.querySelector('.dm-header');
      const top = () => this.style.setProperty('--dm-sticky-top', (head && getComputedStyle(head).position === 'sticky' ? head.offsetHeight : 0) + 'px');
      top(); addEventListener('resize', top, { passive: true });
      // Kachelbilder ab der 5. erst kurz vor dem Sichtbarwerden laden (data-src → src)
      const load = (li) => li.querySelectorAll('img[data-src]').forEach((i) => { if (i.dataset.srcset) { i.sizes = i.dataset.sizes || ''; i.srcset = i.dataset.srcset; } i.src = i.dataset.src; i.removeAttribute('data-src'); });
      const io = 'IntersectionObserver' in window ? new IntersectionObserver((es) => es.forEach((e) => { if (e.isIntersecting) { load(e.target); io.unobserve(e.target); } }), { rootMargin: '300px 0px' }) : null;
      this.items.forEach((li) => { if (li.querySelector('img[data-src]')) io ? io.observe(li) : load(li); });
      this.render();
    }
    sort(mode) {
      const by = {
        emp: (a, b) => a.dataset.order - b.dataset.order,
        pano: (a, b) => (b.dataset.pano - a.dataset.pano) || (a.dataset.order - b.dataset.order),
        az: (a, b) => a.dataset.title.localeCompare(b.dataset.title, 'de'),
        price: (a, b) => (a.dataset.price - b.dataset.price) || (a.dataset.order - b.dataset.order),
      }[mode] || ((a, b) => a.dataset.order - b.dataset.order);
      this.items.sort(by).forEach((li) => this.grid.appendChild(li));
      this.render();
    }
    render() {
      const match = this.items.filter((li) => this.filter === 'all' || li.dataset.world === this.filter);
      this.items.forEach((li) => (li.hidden = true));
      match.slice(0, this.shown).forEach((li) => (li.hidden = false));
      const promo = $('[data-dm-promo]', this.grid);
      if (promo) { const visible = match.slice(0, this.shown); const after = visible[7]; if (after) { after.after(promo); promo.hidden = false; } else promo.hidden = true; }
      const rest = match.length - this.shown;
      const more = $('[data-dm-more]', this);
      if (more) { more.hidden = rest <= 0; $('[data-dm-rest]', this).textContent = rest; }
      $$('[data-dm-count]', this).forEach((c) => (c.textContent = match.length));
    }
  }
  customElements.define('dm-collection', DmCollection);
})();
